var map = {
	"./google-laurel-da-DK.svg": 48355,
	"./google-laurel-de-DE.svg": 1868,
	"./google-laurel-en-GB.svg": 32568,
	"./google-laurel-en-US.svg": 48746,
	"./google-laurel-es-ES.svg": 10031,
	"./google-laurel-es-MX.svg": 26532,
	"./google-laurel-fr-FR.svg": 65813,
	"./google-laurel-it-IT.svg": 78574,
	"./google-laurel-nb-NO.svg": 46950,
	"./google-laurel-nl-NL.svg": 95979,
	"./google-laurel-pl-PL.svg": 95357,
	"./google-laurel-pt-BR.svg": 26961,
	"./google-laurel-pt-PT.svg": 20468,
	"./google-laurel-sv-SE.svg": 85453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26678;